module.exports = __webpack_public_path__ + "img/search_black_icon.88138456.svg";